import React, { useEffect, useState } from "react";
import FunnelLayout from "~pages/Funnel/components/FunnelLayout";
import FunnelDashboardChart from "./components/DashboardChart";
import ResponseAlert from "~components/Form/components/ResponseAlert";
import { useConfigureFooter } from "~hooks/useHelpers";
import { utils } from "~pages/Funnel/utils";
import { Form, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import FunnelModalShutWork from "~pages/Funnel/components/Modals/ShutWork";
import ModalResponse from "~components/Modal/ModalResponse";
import FunnelVolumeUpdateModal from "~pages/Funnel/components/Modals/VolumeUpdate";
import FunnelProductsUpdateModal from "~pages/Funnel/components/Modals/ProductsUpdate";
import FunnelDashboardContent from "./FunnelDashboardContent";
import "./style.scss";
import useCliente from "~/fetchs/useCliente";
import { useSalvarFunilObras } from "~pages/Funnel/hooks/useFunnel";
import { convertStringInDate } from "~services/GlobalServices";
import { getLocation } from "~services/utils/geoLocation";
import { formatDateToCustomString } from "~pages/PriceSearchV2/utils/searchHelpers";
import { db } from "~db/db";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import useFunilObra from "~fetchs/useFunilObra";

const FunnelDashboard = () => {
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const [labelButton, setLabelButton] = useState("Atualizar");
  const [filters, setFilters] = useState({
    order: "",
    grupoProduto: "",
    sku: "",
    dataNegociacao: "",
  });

  const { parameter: clienteId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();

  const ativas = location.pathname.includes("/ativas");

  const [searchParams] = useSearchParams();
  const origem = searchParams.get("origem");

  const funisConsolidados = clienteId == undefined;
  const table = funisConsolidados ? db.funilObraDashboard : db.funilObraNaoSalvo;

  useConfigureFooter(
    {
      form: showSubmitButton,
      submitLabel: labelButton,
      formId: "dashboard-form",
    },
    [showSubmitButton]
  );

  const tabs = [
    { name: "Próximas Negociações", link: `${utils.modulePath}/dashboard`, className: "funnel" },
    { name: "Obras Ativas", link: `${utils.modulePath}/dashboard/ativas`, className: "funnel" },
  ];

  const { cliente } = useCliente(clienteId);

  const [orderFilter, setOrderFilter] = useState({ label: "Grupo de produto", value: "grupoNome" });
  const [funilStatusObj, setFunilStatusObj] = useState({});
  const [statusGanha, setStatusGanha] = useState(null);
  const [dashFilterNotIn, setDashFilterNotIn] = useState([]);
  const [dashFilterGanha, setDashFilterGanha] = useState(null);
  const [toCheckGroups, setToCheckGroups] = useState(null);

  const [showResponse, setShowResponse] = useState(false);
  const [hasWonWorks, setHasWonWorks] = useState(false);

  const chartTitle = clienteId || ativas ? "Histograma VS. Consumo" : "Negociações Futuras";

  const { funisObra, definedFilter, workFinished } = useFunilObra({
    clienteId: Number.parseInt(clienteId ?? "0"),
    filters,
    table,
    updateDashboardData: origem != "edicao",
    obrasAtivas: ativas,
  });
  // const { obrasAtivas, obrasAtivasFormatadas, availableFilters: availableFiltersAtivas } = useObrasAtivas({ clienteId: parseInt(clienteId ?? "0") });

  const chartColumns = clienteId
    ? ["Histograma", "Volume consumido"]
    : ativas
    ? ["Consumido", "Previsto"]
    : ["Volume de Obras", "Qtd. de Obras"];

  const [showShutWorkModal, setShowShutWorkModal] = useState(false);
  const [toShutWork, setToShutWork] = useState(false);
  const [showResponseShutWorkModal, setShowResponseShutWorkModal] = useState(false);

  const [showVolumeUpdateModal, setShowVolumeUpdateModal] = useState(false);
  const [showProductsUpdateModal, setShowProductsUpdateModal] = useState(false);

  const {
    isModalOpen,
    closeModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    openModal,
    setSubmessageStatus,
    submessageStatus,
  } = useModalResponse();

  const handleShutWork = () => {
    setShowShutWorkModal(true);
  };

  const handleSaveProductsUpdate = () => {
    setShowProductsUpdateModal(false);
    setShowResponse(true);
  };

  const handleSaveVolumeUpdate = async (e) => {
    const { obj } = e;
    if (obj && obj.list) {
      for (const [key, value] of Object.entries(obj.list)) {
        const id = key;
        const data = await db.funilObraNaoSalvo.where("id").equals(Number.parseInt(id)).first();
        const funilObraJustificativaId = obj.single?.funilObraJustificativaId;
        if (data) {
          await db.funilObraNaoSalvo.update(Number.parseInt(id), {
            ...data,
            corinthians: true,
            volumeEstimado: value.volumeTotal,
            funilObraJustificativaId:
              funilObraJustificativaId && !Number.isNaN(funilObraJustificativaId) ? funilObraJustificativaId : null,
          });
        }
      }
    }
    handleSaveSubmit({});
    setShowVolumeUpdateModal(false);
  };

  const [loading, setLoading] = useState(false);

  const onSuccess = async () => {
    const obraFechada = toShutWork;
    if (toShutWork) {
      setShowResponseShutWorkModal(true);
      setToShutWork(false);
    }
    if (clienteId) {
      const data = [];
      await db.funilObraNaoSalvo
        .where("clienteId")
        .equals(Number.parseInt(clienteId))
        .each((e) =>
          data.push({
            ...e,
            dataEncerramento: obraFechada ? formatDateToCustomString(new Date()) : null,
          })
        );
      if (data.length > 0) {
        await db.funilObraNaoSalvo.bulkPut(data);
      }
    }
    setLoading(false);
  };

  const redirectOnSuccess = () => {
    if (origem == "edicao") navigate(`${utils.modulePath}/${clienteId}/dashboard`);
  };

  const onError = () => {
    setLoading(false);
  };

  const [funilObras, setFunilObras] = useState([]);

  const funilObrasSalvar = useSalvarFunilObras(funilObras, onSuccess, onError);

  const setModalMessage = ({ message, submessage, status }) => {
    if (message?.length || submessage?.length) {
      if (message?.length > 0) setMessageStatus(message);

      if (submessage?.length > 0) setSubmessageStatus(submessage);

      openModal(status || "warning");
    }
  };

  const checkGroupsVolumes = async () => {
    if (clienteId) {
      let dados = [];
      await db.funilObraNaoSalvo
        .where("clienteId")
        .equals(Number.parseInt(clienteId))
        .each((e) => dados.push(e));

      const grupoChecar = Object.values(
        dados.reduce((acc, cur) => {
          const key = `${cur.etapa}-${cur.funilObraGrupoProdutoId}`;
          if (!acc[key]) {
            acc[key] = {
              leader: null,
              volumeSkus: 0,
              etapa: cur.etapa,
              funilObraGrupoProdutoId: cur.funilObraGrupoProdutoId,
            };
          }

          if (cur.funilObraProdutoId) {
            acc[key].volumeSkus += cur.volumeEstimado;
          } else {
            acc[key].leader = cur;
          }

          return acc;
        }, {})
      ).reduce((result, { leader, volumeSkus, etapa, funilObraGrupoProdutoId }) => {
        if (volumeSkus > 0 && leader && leader.volumeEstimado > volumeSkus) {
          result.push({
            id: leader.id,
            grupo: leader,
            funilObraGrupoProdutoId,
            etapa,
            volumeSkus,
            volumeGrupo: leader.volumeEstimado,
          });
        }
        return result;
      }, []);

      if (grupoChecar.length > 0) {
        setToCheckGroups(grupoChecar);
        return true;
      } else {
        return false;
      }
    }
  };

  useEffect(() => {
    if (toCheckGroups) {
      setShowVolumeUpdateModal(true);
    }
  }, [toCheckGroups]);

  const handleSaveSubmit = async ({ shutWork = false, reopen = false }) => {
    let dados = [];
    const curDate = formatDateToCustomString(new Date());
    if (clienteId)
      await db.funilObraNaoSalvo
        .where("clienteId")
        .equals(Number.parseInt(clienteId))
        .each((e) =>
          dados.push({
            ...e,
            dataEncerramento: shutWork && !reopen ? curDate : null,
          })
        );
    else {
      let tempData = [];
      await db.funilObraDashboard.filter((e) => (ativas ? e.updated : true)).each((e) => tempData.push(e));
      if (ativas) {
        let negociacoesIds = [...new Set(tempData.map((e) => e.numeroPedido))];
        if (Array.isArray(negociacoesIds) && negociacoesIds.length > 0) {
          await db.funilObraDashboard.filter((e) => negociacoesIds.includes(e.numeroPedido)).each((e) => dados.push(e));
        }
      }
    }
    if (dados) {
      let pos = await getLocation();
      for (const e of Object.keys(pos)) {
        pos[e] = pos[e] ? pos[e].toString() : null;
      }
      const submit = [];
      for (const el of dados || []) {
        submit.push({
          etapa: el.etapa,
          funilObraGrupoProdutoId: el.funilObraGrupoProdutoId,
          funilObraProdutoId: el.funilObraProdutoId,
          dataNegociacao: el.dataNegociacao?.length > 0 ? convertStringInDate(el.dataNegociacao, "ISO") : null,
          inicioConsumoEstimado: el.inicioConsumo ? convertStringInDate(el.inicioConsumo ?? null, "ISO") : null,
          fimConsumoEstimado: el.fimConsumo ? convertStringInDate(el.fimConsumo ?? null, "ISO") : null,
          volumeEstimado: el.volumeEstimado,
          unidadeMedidaId: el.unidadeMedidaId,
          clienteId: Number.parseInt(el.clienteId),
          dataEncerramento: el.dataEncerramento ?? null,
          encerrada: false,
          funilStatusId: el.funilStatusId ?? null,
          principalMotivoCompraId: el.principalMotivoCompraId ?? null,
          consorcio: el.consorcio ?? false,
          funilObraEmpresaLiderId: el.funilObraEmpresaLiderId ?? null,
          funilObraConsorcioId: el.funilObraConsorcioId ?? null,
          motivoPerdaId: el.motivoPerdaId ?? null,
          funilObraConcorrenteId: el.funilObraConcorrenteId ?? null,
          funilObraJustificativaId: el.funilObraJustificativaId ?? null,
          contextoId: el.contextoId ?? null,
          nivelServicoId: el.nivelServicoId ?? null,
          nomeInformante: el.nomeInformante ?? null,
          prazoConcorrente: el.prazoConcorrente ?? null,
          prazoVC: el.prazoVC ?? null,
          precoConcorrente: el.precoConcorrente ?? 0,
          precoVC: el.precoVC ?? 0,
          tipoConsumoConcreto: el.tipoConsumoConcreto ?? null,
          filialId: el.filialId ?? null,
          indiceReajuste: el.indiceReajuste ?? null,
          dataReajuste: el.dataReajuste ? convertStringInDate(el.dataReajuste ?? null, "ISO") : null,
          createdAt: curDate,
          ...pos,
          numeroPedido: el.numeroPedido ?? null,
          ultimaAtualizacao: el.ultimaAtualizacao,
          primeiraPesquisa: el.primeiraPesquisa,
        });
      }
      if (shutWork && !reopen) {
        setShowResponseShutWorkModal(false);
        setToShutWork(true);
      }
      setLoading(true);
      setFunilObras(submit);
    }
  };

  useEffect(() => {
    if (funilObras.length > 0) {
      setLoading(true);

      funilObrasSalvar();
    }
  }, [funilObras]);

  useEffect(() => {
    if (funisObra?.length && statusGanha) {
      if (statusGanha?.id) {
        setHasWonWorks(funisObra.some((e) => e.funilStatusId == statusGanha.id));
      }
    }

    if (statusGanha?.id) {
      setDashFilterGanha(() => {
        return (e) => (funisConsolidados && e.funilStatusId === statusGanha.id ? e.dashboard : true);
      });
    }
  }, [statusGanha, funisObra]);

  useEffect(() => {
    if (funilStatusObj && Object.entries(funilStatusObj)?.length) {
      const ganha = Object.values(funilStatusObj).find((e) => e.nome == "Ganha");
      const ganhaId = ganha?.id;
      if (ganhaId) {
        setStatusGanha(ganha);
      }

      if (funisConsolidados) {
        setDashFilterNotIn((prev) => ({
          ...prev,
          funilStatusId: Object.values(funilStatusObj)
            .filter((e) => e.nome != "Em Negociação")
            .map((e) => e.id),
        }));
      }
    }
  }, [funilStatusObj]);

  return (
    <FunnelLayout
      cliente={cliente}
      workFinished={workFinished}
      filter
      canShutWork
      handleShutWork={handleShutWork}
      tabs={cliente ? false : tabs}
      orderFilter={orderFilter}
      setOrderFilter={setOrderFilter}
      className="dashboard-page"
      setFilters={setFilters}
      filters={filters}
      definedFilter={definedFilter}
      hideFilters={cliente ? false : true}
    >
      <Form
        id="dashboard-form"
        onSubmit={async (e) => {
          e.preventDefault();
          if (clienteId) {
            checkGroupsVolumes().then((res) => {
              if (!res) {
                handleSaveSubmit({});
              }
            });
          } else {
            handleSaveSubmit({});
          }
        }}
      >
        <div className="container content">
          {funisObra?.length > 0 && hasWonWorks && (
            <FunnelDashboardChart
              funnelData={funisObra.map((e) => {
                return {
                  dataNegociacao: e.dataNegociacao,
                  inicioConsumo: e.inicioConsumo,
                  fimConsumo: e.fimConsumo,
                  status: funilStatusObj[`id-` + e.funilStatusId]?.nome,
                  volumeEstimado: e.volumeEstimado,
                };
              })}
              activeWorksData={funisObra}
              columns={chartColumns}
              title={chartTitle}
              renderOnEnd={cliente ? true : false}
              accordion={cliente ? true : false}
              tipo={clienteId || ativas ? "histograma-consumo" : "negociacoes-futuras"}
            />
          )}

          <FunnelDashboardContent
            workFinished={workFinished}
            loading={loading}
            setModalMessage={setModalMessage}
            orderFilter={orderFilter}
            origem={origem}
            cliente={cliente}
            setShowSubmit={setShowSubmitButton}
            setLabelButton={setLabelButton}
            obrasAtivas={funisObra}
            funisObra={funisObra.filter((e) => (typeof dashFilterGanha == "function" ? dashFilterGanha(e) : e))}
            dashFilterGanha={dashFilterGanha}
            setFunilStatusObj={setFunilStatusObj}
            funisConsolidados={funisConsolidados}
            table={table}
            filters={filters}
            ativas={ativas}
          />

          <ResponseAlert
            status="sucess"
            text="Salvo com Sucesso"
            show={showResponse}
            setShow={setShowResponse}
            fixed={true}
          />
        </div>
      </Form>

      <FunnelModalShutWork
        show={showShutWorkModal}
        setShow={setShowShutWorkModal}
        onConfirm={() => {
          handleSaveSubmit({ shutWork: true, reopen: workFinished });
        }}
      />

      <ModalResponse
        status={"success"}
        message={"Obra encerrada com sucesso."}
        isOpen={showResponseShutWorkModal}
        closeModal={() => {
          setShowResponseShutWorkModal(false);
          redirectOnSuccess();
        }}
      />

      <FunnelVolumeUpdateModal
        isOpen={showVolumeUpdateModal}
        setIsOpen={setShowVolumeUpdateModal}
        submitHandler={handleSaveVolumeUpdate}
        values={toCheckGroups}
      />

      <FunnelProductsUpdateModal
        isOpen={showProductsUpdateModal}
        setIsOpen={setShowProductsUpdateModal}
        submitHandler={handleSaveProductsUpdate}
      />

      <ModalResponse
        isOpen={isModalOpen}
        closeModal={closeModal}
        status={modalStatus}
        message={messageStatus}
        submessage={submessageStatus}
        button="Ok"
      />
    </FunnelLayout>
  );
};

export default FunnelDashboard;
